import { render, staticRenderFns } from "./pushSetting.vue?vue&type=template&id=75199258&"
import script from "./pushSetting.vue?vue&type=script&lang=js&"
export * from "./pushSetting.vue?vue&type=script&lang=js&"
import style0 from "./pushSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports